export default {
	methods: {
		validation() {
			return {
				email(email) {
					const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return re.test(String(email).toLowerCase());
				},
				url(url) {
					if (url) {
						const res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
						return (res !== null);
					}
					return false;
				},
				resolveState({ errors, pending, valid }, hideSuccess = false) {
					if (errors[0]) {
						return 'error';
					}

					if (pending) {
						return 'validating';
					}

					if (valid && !hideSuccess) {
						return 'success';
					}

					return '';
				},
			};
		},
	},
};
